// extracted by mini-css-extract-plugin
export default {"wrapper":"FormikTextarea_wrapper__m0tZ0","error":"FormikTextarea_error__UN88a","input":"FormikTextarea_input__l0OSX","white":"FormikTextarea_white__pcaJQ"};